import styled from 'styled-components'

export const IconContainer = styled.div`
  cursor: inherit;
  height: 20px;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const IconWithText = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 0;

  ${IconContainer} {
    display: none;
  }

  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    ${IconContainer} {
      display: flex;
    }
  }
`
